var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length)?_c('div',[_vm._l((_vm.list),function(item){return [_c(item.component,_vm._b({key:item.id,ref:item.id,refInFor:true,tag:"component"},'component',item.props,false))]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }